import { global } from "../../constants";

export const data = {
    banner: {
        base: "Inicio",
        background: global.banner + "ci1.webp",
        title: "Identidad Corporativa",
        crumb: "Identidad Corporativa"
    },

    identity : {
        OurMission: {
            title: "Nuestra Misión",
            description: "Ser una empresa de vanguardia que brinda servicios operativos, legales y técnicos en el sector marítimo, ayudando a nuestros socios comerciales a alcanzar sus objetivos internacionales.",
            image: global.icons + "our-mission.png",
        },

        OurVision: {
            title: "Nuestra Visión",
            description: "Convertirnos en un referente en la prestación de servicios de consultoría, operación y gestión a todo tipo de empresas, especialmente aquellas relacionadas con el transporte marítimo nacional e internacional; ofrecer cursos y seminarios en este ámbito, y ser un aliado del ente rector en la búsqueda de las mejores prácticas en las actividades marítimas.",
            image: global.icons + "our-vision.png",
        },
        OurValues: {
            title: "Nuestros Valores",
            description: "Estamos comprometidos con la disciplina, el apego a las normas nacionales e internacionales, el cumplimiento de las leyes de los diversos países donde prestamos nuestros servicios, la lealtad, el trabajo arduo y la búsqueda de la calidad para nuestros socios comerciales.",
            image: global.icons + "our-values.png",
            values: [
                "Disciplina",
                "Apego a las normas nacionales e internacionales",
                "Cumplimiento de las leyes de los diversos países donde prestamos nuestros servicios",
                "Lealtad",
                "Trabajo arduo",
                "Búsqueda de calidad para nuestros socios comerciales"
            ]
        },
    },
}